import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { SidebarInset } from '@/components/ui/sidebar';
    import { computed } from 'vue';

    interface Props {
        variant?: 'header' | 'sidebar';
        class?: string;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AppContent',
  props: {
    variant: {},
    class: {}
  },
  setup(__props: any) {

    const props = __props;
    const className = computed(() => props.class);

return (_ctx: any,_cache: any) => {
  return (props.variant === 'sidebar')
    ? (_openBlock(), _createBlock(_unref(SidebarInset), {
        key: 0,
        class: _normalizeClass(className.value)
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["class"]))
    : _createCommentVNode("", true)
}
}

})